import { produce } from 'immer';

import { actionTypes } from './constants';
import * as Types from './types';

export const defaultState: Types.IMyAccountSidebarState = {
    name: null,
    isOpened: false,
    headerWcId: null,
    footerWcId: null,
    portalPageURL: null,
    isBackArrowHidden: false,
    sidebarPosition: 'right',
    sidebarMenu: {
        height: 'auto',
        subMenuItems: null,
        mainMenuItems: null,
        isSubMenuShown: false,
        transitionDuration: 300
    }
};

export const reducer = produce((draftState, action: Types.TMyAccountSidebarAction): Types.IMyAccountSidebarState | void => {
    switch (action.type) {
        case actionTypes.MY_ACCOUNT_SIDEBAR_DATA_UPDATE: {
            const { headerWcId, footerWcId, menuItems } = action.payload;

            draftState.headerWcId = headerWcId;
            draftState.footerWcId = footerWcId;
            draftState.sidebarMenu.mainMenuItems = menuItems;

            break;
        }

        case actionTypes.MY_ACCOUNT_SIDEBAR_TOGGLE: {
            draftState.isOpened = !draftState.isOpened;

            break;
        }

        case actionTypes.MY_ACCOUNT_SIDEBAR_CLOSE: {
            Object.assign(draftState, defaultState);

            break;
        }

        case actionTypes.MY_ACCOUNT_SIDEBAR_OPEN: {
            draftState.isOpened = true;

            break;
        }

        case actionTypes.MY_ACCOUNT_SIDEBAR_NAME_CHANGE: {
            draftState.name = action.payload;

            break;
        }

        case actionTypes.MY_ACCOUNT_SIDEBAR_MENU_HEIGHT_CHANGE: {
            draftState.sidebarMenu.height = action.payload;

            break;
        }

        case actionTypes.MY_ACCOUNT_SIDEBAR_MENU_ITEMS_MAIN_MENU_SHOW: {
            Object.assign(draftState.sidebarMenu, {
                isSubMenuShown: false
            });

            break;
        }

        case actionTypes.MY_ACCOUNT_SIDEBAR_MENU_ITEMS_SUB_MENU_SHOW: {
            Object.assign(draftState.sidebarMenu, {
                isSubMenuShown: true,
                subMenuItems: action.payload
            });

            break;
        }

        case actionTypes.MY_ACCOUNT_SIDEBAR_PORTAL_PAGE_SHOW: {
            const { pageURL, isBackArrowHidden } = action.payload;

            Object.assign(draftState, {
                portalPageURL: pageURL,
                isBackArrowHidden: Boolean(isBackArrowHidden)
            });

            break;
        }

        case actionTypes.MY_ACCOUNT_SIDEBAR_HOME_PAGE_SHOW: {
            Object.assign(draftState, {
                name: null,
                portalPageURL: null
            });

            break;
        }

        default: {
            break;
        }
    }
}, defaultState);
